<template>
    <div>
        <v-menu
        offset-y
        >
        <template v-slot:activator="{ attrs, on }">
            <v-btn
            class="ma-5"
            v-bind="attrs"
            small
            v-on="on"
            >
            <v-icon left>
                mdi-calendar
            </v-icon>
            {{label}} {{options[selected]}}
            <span v-if="customDate">
                {{ getJalaliDate(customDate[0] * 1000, 'jYYYY/jMM/jDD HH:mm:ss ') }}
                    تا
                {{ getJalaliDate(customDate[1] * 1000, 'jYYYY/jMM/jDD HH:mm:ss ') }}
            </span>
            </v-btn>
        </template>

        <v-list>
            <v-list-item
            v-for="(label, key) in options"
            :key="key"
            link
            >
                <v-list-item-title v-text="label" @click="setValue(key)"></v-list-item-title>
            </v-list-item>
        </v-list>
        
        </v-menu>
        <date-picker
            :show="displayCalendar"
            @close="displayCalendar=false"
            v-model="customDate"
            :element=elementDatePicker
            format="X"
            range
            display-format="jYYYY/jMM/jDD HH:mm:ss"
            type="date"
        />
    </div>
</template>
<script>
import Moment from 'moment-jalaali';

export default {
    created(){
        this.setValue(this.default);
    },
    computed : {
        elementDatePicker(){
            return `#${this.id}`;
        },
    },
    props : {
        id : {
            type : String,
            default : 'date_options_' + (new Date).getTime(),
        },
        default : {
            type : String,
            default : 'currentWeek',
            required: true
        },
        label : {
            type : String,
            default : 'نمایش :‌'
        },
        value : {
            type : Array
        }
    },
    watch : {
        customDate(newVal){
            if(newVal){
                this.$emit('input', this.customDate)
            }
        }
    },
    data(){
        return {
            customDate : null,
            displayCalendar : false,
            selected : null,
            options : {
                'today' : 'امروز',
                'yesterday' : 'دیروز',
                'currentWeek' : 'هفته جاری',
                'lastWeek' : 'هفته گذشته',
                'currentMonth' : 'ماه جاری',
                'lastMonth' : 'ماه گذشته',
                'currentYear' : 'سال جاری',
                'lastYear' : 'سال گذشته',
                'custom' : 'تاریخ سفارشی'
            }
        }
    },
    methods : {
        setValue(key){
            this.selected = key;
            this.customDate = null;
            if(key == 'custom'){
                this.displayCalendar = true;
            }else{
                this.$emit('input', this.getDates(key))
            }
        },
        getDates(key){
            let from;
            let to;
            switch (key){
                case 'today':
                    from = Moment().startOf('day').unix();
                    to = Moment().endOf('day').unix();
                break;
                case 'yesterday':
                    from = Moment().add(-1, 'day').startOf('day').unix();
                    to = Moment().add(-1, 'day').endOf('day').unix();
                    break;
                case 'currentWeek':
                    from = Moment().startOf('week').unix();
                    to = Moment().endOf('week').unix();
                    break;
                case 'lastWeek':
                    from = Moment().subtract(1, 'weeks').startOf('week').unix();
                    to = Moment().subtract(1, 'weeks').endOf('week').unix();
                    break;
                case 'currentMonth':
                    from = Moment().startOf('jMonth').unix();
                    to = Moment().endOf('jMonth').unix();
                    break;
                case 'lastMonth':
                    from = Moment().subtract(1, 'months').startOf('jMonth').unix();
                    to = Moment().subtract(1, 'months').endOf('jMonth').unix();
                    break;
                case 'currentYear':
                    from = Moment().startOf('jYear').unix();
                    to = Moment().endOf('jYear').unix();
                    break;
                case 'lastYear':
                    from = Moment().subtract(1, 'years').startOf('jYear').unix();
                    to = Moment().subtract(1, 'years').endOf('jYear').unix();
                    break;
                default:
                    throw Error(`the key ${key} not define for date options`);
            }

            return [from, to]
        }
    }
}

</script>